/**
 * Prefix of the synthetic StripePaymentIntent ids written for $0 checkouts; Stripe has
 * never seen these ids. Covers both `free_checkout_<paymentId>` and
 * `free_checkout_setup_<paymentId>`.
 */
export const FREE_CHECKOUT_PAYMENT_INTENT_ID_PREFIX = 'free_checkout_';

export function isFreeCheckoutPaymentIntentId(paymentIntentId: string): boolean {
	return paymentIntentId.startsWith(FREE_CHECKOUT_PAYMENT_INTENT_ID_PREFIX);
}
